import { getPublicLinks, getSocialsPublic } from '@/api/profile';
import { get as getWidgets } from '@/api/widgets';
import { get as getProfileDesign } from '@/api/design';
import { HEXToRGB, WidgetShapesWithUnavailableBoxShadow } from '@/utils/design';
import { getFeed } from '@/api/content';
import userMessages from '@/mixins/user-messages';


export default {
  mixins: [userMessages],
  namespaced: true,
  state: {
    design: {},
    socials: {},
    widgets: [],
    content: [],
  },
  getters: {
    widgets: state => state.widgets,
    design: state => state.design,
    socials: state => state.socials,
    content: state => state.content,
    userProfile: state => state,
  },
  mutations: {
    setDesign(state, design) {
      state.design = design;
    },
    setSocials(state, socials) {
      state.socials = socials;
    },
    setWidgets(state, widgets) {
      state.widgets = widgets;
    },
    setContent(state, content) {
      state.content = content;
    },
  },
  actions: {
    setTheme({ getters }) {
      if (!getters.design) return;

      const previewScreenEl = document.querySelector('.dashboard-preview-screen');

      const theme = getters.design.theme;

      if (theme === 0 && getters.design.cssVariables) {
        Object
          .entries(getters.design.cssVariables)
          .forEach(([key, value]) => {
            if (key === '--secondary-color-values') {
              previewScreenEl.style.setProperty(key, HEXToRGB(value));
            } else {
              previewScreenEl.style.setProperty(key, value);
            }
          });
      } else {
        Object
          .entries(getters.design.cssVariables)
          .forEach(([key]) => {
            previewScreenEl.style.setProperty(key, '');
          });
      }

      previewScreenEl.dataset.theme = theme;

      if (WidgetShapesWithUnavailableBoxShadow.includes(getters.design.widgetShape) && getters.design.boxShadowEnabled) {
        return;
      }

      if (getters.design.boxShadowEnabled) {
        previewScreenEl.style.removeProperty('--link-boxShadow');
      }
    },
    async getSocials({ commit }, userId) {
      try {
        const { data } = await getSocialsPublic(userId);
        commit('setSocials', data);
      } catch (e) {
        this.setErrorMessage(e);
      }
    },
    async getPublicLinks({ commit }, id) {
      try {
        const { data } = await getPublicLinks(id);
        commit('setWidgets', data);
      } catch (e) {
        this.setErrorMessage(e);
      }
    },
    async getWidgets({ commit }, id) {
      try {
        const { data } = await getWidgets(id);
        commit('setWidgets', data);
      } catch (e) {
        this.setErrorMessage(e);
      }
    },
    async getDesign({ commit, dispatch }, id) {
      try {
        const { data } = await getProfileDesign(id);
        commit('setDesign', data);
        dispatch('setTheme');
      } catch (e) {
        this.setErrorMessage(e);
      }
    },
    async getContent({ commit, rootGetters }, id) {
      const query = rootGetters['profile/content/query'];
      const { data } = await getFeed(id, query);
      commit('setContent', data.feed);
    },
    setUserProfile({ commit, dispatch }, userProfile) {
      commit('setDesign', userProfile.design);
      commit('setSocials', userProfile.socials);
      commit('setWidgets', userProfile.widgets);
      commit('setContent', userProfile.content);
      dispatch('setTheme');
    },
  },
};
